import { DateTime } from "luxon";

export const getAppointmentIso = (service: any) =>
  service?.appointmentDate || service?.vehicleService?.appointmentDate;

export const getBranchTimeZone = (branches: any[] | undefined, branchId?: string) =>
  branches?.find((b) => b.id === branchId)?.timeZone || branches?.[0]?.timeZone || "Europe/London";

export const formatAppointmentDate = (iso: string | undefined, country: string, timeZone: string) => {
  if (!iso) return "—";
  return DateTime.fromISO(iso, { zone: timeZone }).toFormat("dd/MM/yyyy");
};

export const formatAppointmentTime = (iso: string | undefined, timeZone: string) => {
  if (!iso) return "—";
  return DateTime.fromISO(iso, { zone: timeZone }).toFormat("h:mm a");
};

export const toDateInput = (iso: string | undefined, timeZone: string) => {
  if (!iso) return "";
  return DateTime.fromISO(iso, { zone: timeZone }).toFormat("yyyy-MM-dd");
};

export const toTimeInput = (iso: string | undefined, timeZone: string) => {
  if (!iso) return "";
  return DateTime.fromISO(iso, { zone: timeZone }).toFormat("HH:mm");
};

export const combineDateAndTime = (date: string, time: string, timeZone: string) => {
  if (!date || !time) return undefined;
  return DateTime.fromFormat(`${date} ${time}`, "yyyy-MM-dd HH:mm", { zone: timeZone })
    .toUTC()
    .toISO();
};

export const getVehicleLabel = (vehicle: any) => {
  if (!vehicle) return "—";
  const name = [vehicle.make, vehicle.model, vehicle.year ? `(${vehicle.year})` : ""]
    .filter(Boolean)
    .join(" ");
  return name || vehicle.licencePlate || "—";
};

export const getJobItems = (service: any) => {
  const items = service?.vehicleService?.jobSheet || service?.jobSheet || [];
  return items
    .map((item: any) => item.name || item.task || item.description || item.taskDescription)
    .filter(Boolean);
};

export const canReviewScheduledService = (service: any) => {
  if (!service || service.consumerApproved) {
    return false;
  }
  if (service.isAppointmentDateRequestModified) {
    return true;
  }
  const status = (service.vehicleService?.status || service.status || "").toUpperCase();
  if (["PENDING", "PENDING APPROVAL", "DECLINED", "CANCELLED"].includes(status)) {
    return false;
  }
  return ["SCHEDULED", "NOT_STARTED", "APPROVED"].includes(status);
};
